

<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Detalle Pedido Interno</h4>

        <!--<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
        </button>-->
    </div>
    <div class="modal-body">
        <div class="columns col-12">
            <ngx-table #tableModal
                [configuration]="configurationModal"
                [data]="dataModal"
                [columns]="columnsModal"
            ></ngx-table>
            
            <ng-template #frmDocDate let-row let-rowIndex="rowIndex">                                    
                <div>
                    {{row.DocDate | date:'dd/MM/yyyy'}}
                </div>
            </ng-template>

            <ng-template #frmDocDueDate let-row let-rowIndex="rowIndex">                                    
                <div>
                    {{row.DocDueDate | date:'dd/MM/yyyy'}}
                </div>
            </ng-template>

            <ng-template #frmDocTotal let-row let-rowIndex="rowIndex">                                    
                <div>
                    {{row.DocTotal | iNDCLP}}
                </div>
            </ng-template>

        </div>

    </div>
    <div class="modal-footer">
        <button (click)="cerrar()" type="button" class="btn btn-success">Cerrar</button>
    </div>
</div>

